import { NOT_FOUND } from 'redux-first-router';

export default (state = 'START', action = {}) => components[action.type] || state;

const components = {
	START: 'Page',
	SEARCH: 'Search',
	MAGAZINE_LIST: 'Magazine',
	MAGAZINE: 'Page',
	SELECTION: 'Selection',
	SELECTION_PAYMENT_LINK: 'Selection',
	SELECTION_FAILED: 'Page',
	RECEIPT: 'Receipt',
	RECEIPT_DEBUG: 'Receipt',
	REFERRAL: 'Referral',
	CATEGORY_PRODUCT_PAGE: 'CatchAll',
	CATEGORY: 'Category',
	PRODUCT: 'Product',
	FAVOURITES: 'Favourites',
	LOG_IN: 'Login',
	LOG_OUT: 'Logout',
	REGISTER: 'Register',
	FORGOT: 'Forgot',
	ACCOUNT: 'Account',
	[NOT_FOUND]: 'Page',
};
